/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React, { RefObject } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const useStyles = makeStyles((theme) => ({
    unSelected: {
        ...theme.custom.apiOverviewPage.leftMenu.menuItems.unSelected
    },
    selected: {
        ...theme.custom.apiOverviewPage.leftMenu.menuItems.selected
    },
    listItemIcon: {
        ...theme.custom.apiOverviewPage.leftMenu.menuItems.iconStyles
    },
    listItemText: {
        ...theme.custom.apiOverviewPage.leftMenu.menuItems.textStyles
    }
}));

interface ListItemLinkProps {
    icon?: React.ReactElement<SvgIconProps>,
    primary: string,
    to: string,
    selected: boolean,
    id?: string,
    disabled?: boolean,
    onclick?: () => void;
}

function ListItemLink(props: ListItemLinkProps) {
    const { icon, primary, to, selected, id, disabled, onclick } = props;
    const classes = useStyles();
    const ItemRouterLink = React.forwardRef((itemProps, ref) => <RouterLink to={to} ref={ref as RefObject<HTMLAnchorElement>} {...itemProps} />);
    ItemRouterLink.displayName = 'ItemRouterLink';
    const renderLink = React.useMemo(
        () => ItemRouterLink,
        [to],
    );

    return (
        <li data-testid={"li-" + id} onClick={onclick}>
            <ListItem
                button
                component={renderLink}
                className={selected ? classes.selected : classes.unSelected}
                disableRipple={true}
                disableTouchRipple={true}
                data-testid={id}
                disabled={disabled}
            >
                {icon ? <ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon> : null}
                <ListItemText classes={{ primary: classes.listItemText }}>{primary}</ListItemText>
            </ListItem>
        </li>
    );
}

export default ListItemLink;
